import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import toTitleCase from '@clearscore/normalize.title-case';

import styles from './circle.css';
import { themes } from '../../constants';

const Circle = ({ progress, theme, strokeWidth, size, duration, onComplete, adjustmentRotation }) => {
    const themeClass = styles[`isTheme${toTitleCase(theme)}`];
    const circleClass = cx(styles.circle, themeClass);
    const radius = size / 2 - strokeWidth * 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - progress * circumference;

    const handleComplete = (e) => {
        e.stopPropagation();
        onComplete();
    };

    return (
        <circle
            style={{ transitionDuration: `${duration}ms`, transform: `rotate(${adjustmentRotation}deg)` }}
            className={circleClass}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeWidth={strokeWidth}
            onTransitionEnd={handleComplete}
        />
    );
};

Circle.propTypes = {
    progress: PropTypes.number.isRequired,
    theme: PropTypes.oneOf(Object.values(themes)).isRequired,
    strokeWidth: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    duration: PropTypes.number,
    onComplete: PropTypes.func,
    adjustmentRotation: PropTypes.number,
};

Circle.defaultProps = {
    duration: 1000,
    onComplete: undefined,
    adjustmentRotation: -90,
};

export default Circle;
